import logoLightUrl from '@src/assets/images/logo.png'
import logoDarkUrl from '@src/assets/images/logo-dark.png'
import dashboardLightUrl from '@src/assets/images/bowvue_dashboard_light.webp'
import dashboardDarkUrl from '@src/assets/images/bowvue_dashboard_dark.webp'
import bowtieLightUrl from '@src/assets/images/logo_bowtie.webp'
import bowtieDarkUrl from '@src/assets/images/logo_bowtie-dark.webp'

// Images that exist in a light and a dark edition, picked by the active theme.
//
// Imported statically, one per file, rather than built with
// `new URL(`../assets/images/${name}`, import.meta.url)`. A VARIABLE filename
// makes Vite glob the whole directory and emit every image in it: before this,
// a production build shipped 3 MB of images for the ~280 KB the pages actually
// request, including both 1 MB dashboard PNG masters that nothing references.
//
// The BowVue wordmark, in the variant that can actually be read on the current
// background.
//
// logo.png is black ink with a red swoosh. On the dark theme's #121212 the
// wordmark all but disappears, so logo-dark.png carries the same artwork with
// the BLACK recoloured to white; the red swoosh and the "BUILDING LOSS
// PREVENTION" tagline are untouched, because the brand colour reads fine on
// both backgrounds and must not drift.
//
// Shared because three screens show the logo (home, login, new-password) and
// each had its own copy of the URL resolution. One rule here means the dark
// variant cannot be wired into two of them and forgotten in the third.
export function logoUrl(isDark) {
  return isDark ? logoDarkUrl : logoLightUrl
}

// The home page's hero screenshot of the product. Two separate captures rather
// than one recoloured image: it is a picture of the app, so the dark edition has
// to be the app actually in dark mode.
// webp at 1600px, not the 3022px PNG masters: the hero renders at roughly
// 800px, so 1600 is already 2x for a retina display, and the captures drop from
// ~1 MB each to ~57 KB. This is a public marketing page; a megabyte of hero
// image is felt on a phone.
export function dashboardShotUrl(isDark) {
  return isDark ? dashboardDarkUrl : dashboardLightUrl
}

// The Bowtie Engineering wordmark. Both editions are TRANSPARENT: the original
// artwork carried an opaque white background, which read as a lit card on the
// dark theme. Transparency alone was not enough, though, because the wordmark
// is black ink and would simply vanish; the dark edition recolours that ink to
// white and leaves the brand red untouched, exactly like the BowVue logo.
export function bowtieLogoUrl(isDark) {
  return isDark ? bowtieDarkUrl : bowtieLightUrl
}

// isDarkTheme reads Vuetify's current theme, which is reactive, so an image
// swaps the moment the toggle is used rather than on the next navigation.
// `current` is a ref in some Vuetify builds and a plain object in others.
function isDarkTheme(vm) {
  const theme = vm.$vuetify && vm.$vuetify.theme
  const current = theme && theme.current
  const resolved = current && 'value' in current ? current.value : current
  return Boolean(resolved && resolved.dark)
}

// The computed properties the screens mix in. Two bundles rather than one:
// login and new-password show the logo only, and should not carry a computed
// for a picture they never render.
export const logoComputed = {
  logoSrc() {
    return logoUrl(isDarkTheme(this))
  },
}

export const dashboardComputed = {
  dashboardShotSrc() {
    return dashboardShotUrl(isDarkTheme(this))
  },
}

export const bowtieLogoComputed = {
  bowtieLogoSrc() {
    return bowtieLogoUrl(isDarkTheme(this))
  },
}
